import { cn } from "@/lib/utils";
import { Phone } from "lucide-react";
import WhatsAppIcon from "./icons/WhatsAppIcon";

interface WhatsAppButtonProps {
  phoneNumber: string;
  className?: string;
}

// Sticky Call + WhatsApp bar, shown on every page
export const WhatsAppButton = ({ phoneNumber, className }: WhatsAppButtonProps) => {
  const digits = phoneNumber.replace(/\D/g, "");
  return (
    <div className={cn("fixed bottom-4 right-4 z-50 flex flex-col gap-3", className)}>
      <a
        href={`tel:+${digits}`}
        onClick={() => (window as any).gtag_report_conversion?.()}
        className="flex h-14 w-14 items-center justify-center rounded-full bg-dental-highlight text-primary-foreground shadow-lg transition-transform hover:scale-105 active:scale-95"
        aria-label="Call Asrani Dental"
      >
        <Phone size={24} />
      </a>
      <a
        href={`https://wa.me/${digits}`}
        target="_blank"
        rel="noopener noreferrer"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-background shadow-lg transition-transform hover:scale-105 active:scale-95"
        aria-label="Chat on WhatsApp"
      >
        <WhatsAppIcon size={32} />
      </a>
    </div>
  );
};
